export interface ITimetable {
  timetableId: string;
  amenityId: string;
  startHour: string;
  endHour: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  capacity: number;
  canBeBlocked: boolean;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export class Timetable {
  timetableId: string;
  amenityId: string;
  startHour: string;
  endHour: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  capacity: number;
  canBeBlocked: boolean;
  status: boolean;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: ITimetable) {
    this.timetableId = data.timetableId;
    this.amenityId = data.amenityId;
    this.startHour = data.startHour;
    this.endHour = data.endHour;
    this.monday = data.monday;
    this.tuesday = data.tuesday;
    this.wednesday = data.wednesday;
    this.thursday = data.thursday;
    this.friday = data.friday;
    this.saturday = data.saturday;
    this.sunday = data.sunday;
    this.capacity = data.capacity;
    this.canBeBlocked = data.canBeBlocked;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }
}
